import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BTN, INPUT, errMsg } from "../crm/crmUtil";

const STATUS = {
  ok: "Proposal and contract PDFs show this logo.",
  not_set: "No logo set: PDFs show the company name only.",
  missing_file: "The saved logo file is missing: PDFs show the company name only. Pick a logo below.",
  not_allowed: "The saved logo isn't a bundled logo: PDFs show the company name only. Pick a logo below.",
};

// Tenant setting brand.logo_url used on proposal / contract PDFs (bundled logos only; audited).
export default function DocumentBranding() {
  const [b, setB] = useState(null);
  const [pick, setPick] = useState("");
  const [msg, setMsg] = useState({ ok: "", err: "" });
  useEffect(() => { api.get("/sales/branding").then((r) => { setB(r.data); setPick(r.data.status === "ok" ? r.data.logo_url : ""); }).catch((x) => setMsg({ ok: "", err: errMsg(x) })); }, []);
  const save = async () => {
    try { const r = await api.put("/sales/branding/logo", { logo_url: pick || null }); setB(r.data); setMsg({ ok: "Saved.", err: "" }); }
    catch (x) { setMsg({ ok: "", err: errMsg(x) }); }
  };
  if (!b) return msg.err ? <p role="alert" className="text-sm text-red-700">{msg.err}</p> : null;
  return (
    <section className="border border-erf-borderCream rounded bg-white p-3 space-y-2" aria-labelledby="brand-title" data-testid="doc-branding">
      <h3 id="brand-title" className="text-xs uppercase font-nav text-erf-dark/60">PDF logo</h3>
      <p className="text-sm" data-testid="doc-branding-status">{STATUS[b.status] || b.status}</p>
      <label htmlFor="brand-logo" className="text-sm block">Logo
        <select id="brand-logo" value={pick} onChange={(e) => setPick(e.target.value)} className={INPUT} data-testid="doc-branding-select">
          <option value="">No logo (company name only)</option>
          {b.options.map((o) => <option key={o.logo_url} value={o.logo_url}>{o.label}</option>)}
        </select>
      </label>
      {pick && <img src={pick} alt="Selected PDF logo" className="h-12 w-auto border border-erf-borderCream rounded bg-white p-1" data-testid="doc-branding-img" />}
      {msg.err && <p role="alert" className="text-sm text-red-700" data-testid="doc-branding-error">{msg.err}</p>}
      {msg.ok && <p role="status" className="text-sm text-green-800" data-testid="doc-branding-saved">{msg.ok}</p>}
      <button type="button" onClick={save} className={`${BTN} bg-erf-dark text-white`} data-testid="doc-branding-save">Save logo</button>
    </section>
  );
}
